module.exports = __webpack_public_path__ + "static/img/share-order-banner.1103cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/share-order-banner.png
// module id = zUIn
// module chunks = 216